import { api } from "../../api/index.ts";
import { useCallback } from "react";
import {
  driversCreateToExternal,
  driversUpdateToExternal,
} from "../../pages/drivers/converts.ts";
import { DriverForm } from "../../types/shared.ts";

export const useSetDriverData = () => {
  const [triggerCreate] =
    api.endpoints.createDriverApiDriversPost.useMutation();
  const [triggerUpdate] =
    api.endpoints.updateDriverApiDriversDriverIdPut.useMutation();
  const [triggerDelete] =
    api.endpoints.deleteDriverApiDriversDriverIdDelete.useMutation();

  const setData = useCallback(
    async (updatedRows: Partial<DriverForm>[]) => {
      return await Promise.all(
        updatedRows.map((row) => {
          if (row.id) {
            const update = driversUpdateToExternal(row);
            if (Object.entries(update).length !== 0) {
              return triggerUpdate({
                driverId: row.id,
                driverUpdate: update,
              });
            } else {
              return undefined;
            }
          } else {
            return triggerCreate({
              driverCreate: driversCreateToExternal(
                // TODO: Provide fallback default values to ensure this has full set of values
                row as DriverForm,
              ),
            });
          }
        }),
      )
        .then((results) => {
          console.info("Update results ", results);
          return results;
        })
        .catch((err) => {
          console.error(err);
          return null;
        });
    },
    [triggerCreate, triggerUpdate],
  );

  const deleteData = useCallback(
    async (driverId: number) => {
      try {
        const result = await triggerDelete({ driverId });
        console.info("Deleted driver", driverId, result);
        return result;
      } catch (error) {
        console.error("Delete error", error);
        throw error;
      }
    },
    [triggerDelete],
  );

  return { setData, deleteData };
};
